import React, { Suspense, lazy, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import QrCode2Icon from '@mui/icons-material/QrCode2';

// Le QR et son cadre, partages par le bloc d'installation et la page
// d'invitation. Le premier envoie vers l'installation, la seconde vers la suite
// du parcours sur le telephone : meme geste, meme rendu, deux destinations.
//
// collapsible : le QR reste cache derriere un bouton. La page d'invitation s'en
// sert parce que son QR porte le lien personnel du destinataire ; un partage
// d'ecran ou une capture ne doit pas l'emporter sans qu'on l'ait voulu. La page
// d'installation, elle, ne montre que la racine du site et garde son QR visible.

const QrCode = lazy(() => import('qrcode.react').then((m) => ({ default: m.QRCodeSVG })));

const QR_SIZE = 148;
const QR_PADDING = 14;

// Cadre blanc obligatoire : un QR sur fond noir ne se lit pas. La reservation de
// place est identique pendant le chargement pour que rien ne saute.
const QrFrame = ({ children }) => (
  <Box
    sx={{
      width: QR_SIZE + QR_PADDING * 2,
      height: QR_SIZE + QR_PADDING * 2,
      p: `${QR_PADDING}px`,
      borderRadius: '14px',
      backgroundColor: '#ffffff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    {children}
  </Box>
);

const InstallQr = ({
  value,
  title,
  caption = 'Point your phone camera at the code.',
  collapsible = false,
}) => {
  const [shown, setShown] = useState(!collapsible);

  if (!shown) {
    return (
      <Button
        fullWidth
        variant="outlined"
        onClick={() => setShown(true)}
        startIcon={<QrCode2Icon />}
        sx={{
          py: 1.3,
          textTransform: 'none',
          fontSize: '1rem',
          fontWeight: 600,
          color: 'white',
          borderColor: 'rgba(255,255,255,0.25)',
          '&:hover': {
            borderColor: 'rgba(255,255,255,0.5)',
            backgroundColor: 'rgba(255,255,255,0.06)',
          },
        }}
      >
        Show QR code for your phone
      </Button>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <QrFrame>
        <Suspense fallback={null}>
          <QrCode
            value={value}
            size={QR_SIZE}
            level="M"
            marginSize={0}
            bgColor="#ffffff"
            fgColor="#000000"
            title={title}
          />
        </Suspense>
      </QrFrame>
      <Typography
        sx={{ mt: 1.5, fontSize: '0.95rem', color: 'rgba(255,255,255,0.7)', textAlign: 'center' }}
      >
        {caption}
      </Typography>
    </Box>
  );
};

export default InstallQr;
